import ReusableDataTable from "src/components/table/ReusableDataTable";
import { mapColorToDataTable as mapData } from "./Helper";
import GetTTSColorColumns from "./ColumnDefinition/TTSColorColumn/GetTTSColorColumns";

const TTSColorTable = ({ data, handleDelete, handleOpenPopup, status }) => {
  const columns = GetTTSColorColumns({
    handleDelete,
    handleOpenPopup,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default TTSColorTable;
